import React from "react";
import { Box } from "@mui/material";
import { useWindowSize } from "@uidotdev/usehooks";
import { SabiasQueNY, estiloH3NY, estiloPNY } from "./nyHelpers";

// Template80: Día 3 Chinatown & Little Italy (Page6). Contenido desde page.
const Template80 = ({
	headerBackgroundColor,
	headerTextColor,
	fontFamily,
	page,
	updatePage,
}) => {
	const size = useWindowSize();
	const isSmallScreen = size.width <= 600;

	const getImageSrc = (id) => {
		if (page?.images && Array.isArray(page.images)) {
			const found = page.images.find((img) => img?.id === id);
			if (found && found.src) return found.src;
		}
		return undefined;
	};
	const getCanvasImageUrl = (id) => {
		if (page?.canvasImages && Array.isArray(page.canvasImages)) {
			const found = page.canvasImages.find((img) => img?.id === id);
			if (found && found.imageUrl) return found.imageUrl;
		}
		return undefined;
	};

	const title = page?.texts?.[0]?.content;
	const intro = page?.texts?.[1]?.content;
	const heroSubtitle = page?.texts?.[2]?.content;
	const yellowImitaciones = page?.texts?.[3]?.content;
	const streetsRaw = page?.texts?.[4]?.content;
	const sabiasQueRaw = page?.texts?.[5]?.content;
	const columbusRaw = page?.texts?.[6]?.content;
	const comoLlegarTitle = page?.texts?.[7]?.content;
	const comoLlegarLines = page?.texts?.[8]?.content;
	const gastronomiaHtml = page?.texts?.[9]?.content;

	const streets = streetsRaw
		? String(streetsRaw)
				.split(/\n/)
				.map((s) => s.trim())
				.filter(Boolean)
		: [];
	const columbusItems = columbusRaw
		? String(columbusRaw)
				.split(/\n/)
				.map((s) => s.trim())
				.filter(Boolean)
		: [];
	const comoLlegarItems = comoLlegarLines
		? String(comoLlegarLines)
				.split(/\n/)
				.map((s) => s.trim())
				.filter(Boolean)
		: [];

	const sabiasQueChinatown =
		sabiasQueRaw && typeof sabiasQueRaw === "string"
			? (() => {
					const trim = sabiasQueRaw.trim();
					const match = trim.match(/^([^\s]+)\s+(.*)/s);
					return match ? { icono: match[1], texto: match[2].trim() } : null;
			  })()
			: null;

	const chinatownSrc = getImageSrc("chinatown");
	const badgeSrc = getImageSrc("chinatown-badge");
	const columbusSrc = getImageSrc("columbus");
	const comidaSrc = getImageSrc("comida");
	const bolsosSrc = getImageSrc("bolsos");
	const logoSrc = getCanvasImageUrl("logo");

	return (
		<Box
			sx={{
				display: "flex",
				flexDirection: "column",
				minHeight: "100%",
				height: "auto",
				backgroundColor: "#f7f7f7",
				position: "relative",
				"& *": {
					fontFamily: `${fontFamily || "'Poppins', sans-serif"} !important`,
				},
				"& p": { marginTop: "0px !important", marginBottom: "0px !important" },
				"& a": {
					color: "#007a8d",
					fontWeight: 700,
					textDecoration: "underline",
				},
			}}
		>
			<div
				data-block-id="header"
				style={{
					backgroundColor: headerBackgroundColor || "#59c3d8",
					color: headerTextColor || "#fff",
					textAlign: "center",
					padding: "15px 0",
					fontFamily: fontFamily || '"Poppins", sans-serif',
					fontSize: "14px",
					fontWeight: 700,
					flexShrink: 0,
					position: "sticky",
					top: 0,
					zIndex: 9999,
				}}
			>
				{title}
				{logoSrc && (
					<img
						src={logoSrc}
						alt="logo"
						style={{
							width: isSmallScreen ? 66 : 80,
							position: "absolute",
							right: 2,
							top: 18,
							zIndex: 999999,
						}}
					/>
				)}
			</div>

			{chinatownSrc && (
				<div data-block-id="image-0" style={{ position: "relative" }}>
					<img
						src={chinatownSrc}
						alt="Chinatown y Little Italy"
						style={{ width: "100%", height: 200, objectFit: "cover" }}
					/>
					{badgeSrc && (
						<img
							src={badgeSrc}
							alt="badge"
							style={{
								width: 120,
								position: "absolute",
								bottom: -30,
								right: -50,
							}}
						/>
					)}
					{heroSubtitle && (
						<h1
							style={{
								fontFamily: '"Poppins", sans-serif',
								fontSize: 26,
								textAlign: "center",
								position: "absolute",
								bottom: 10,
								left: 20,
								color: "#fff",
								textShadow: "2px 2px 4px rgba(0,0,0,0.6)",
							}}
						>
							{heroSubtitle}
						</h1>
					)}
				</div>
			)}

			<div
				style={{
					padding: "10px 12px",
					paddingTop: "3px",
					flex: 1,
					position: "relative",
				}}
			>
				{intro && (
					<div data-block-id="text-1">
						<p
							style={{
								fontFamily: '"Poppins", sans-serif',
								fontSize: 13,
								color: "#333",
								marginBottom: 12,
								marginTop: -5,
							}}
						>
							{intro.includes("Chinatown") ? (
								<>
									{intro.split("Chinatown")[0]}
									<strong>Chinatown</strong>
									{intro.split("Chinatown").slice(1).join("Chinatown")}
								</>
							) : (
								intro
							)}
						</p>
					</div>
				)}

				{streets.length > 0 && (
					<div data-block-id="text-2" style={{ position: "relative" }}>
						<ul
							style={{
								fontSize: 13,
								paddingLeft: 20,
								color: "#444",
								fontFamily: '"Poppins", sans-serif',
								marginBottom: 12,
								position: "relative",
							}}
						>
							{streets.map((line, i) => (
								<li
									key={i}
									style={{
										listStyle: i === 0 ? "none" : undefined,
										padding: i === 0 ? 0 : undefined,
										marginBottom: 8,
										position: i === 0 ? "relative" : undefined,
									}}
								>
									{i === 0 && bolsosSrc && (
										<div
											style={{
												width: isSmallScreen ? 115 : 90,
												float: "right",
												position: "relative",
											}}
										>
											<img
												src={bolsosSrc}
												alt="Bolsos"
												style={{ width: 80, marginLeft: 35, marginTop: 30 }}
											/>
											{yellowImitaciones && (
												<div
													style={{
														backgroundColor: "#fff8db",
														border: "2px solid #f5c400",
														borderRadius: "16px 16px 0px 16px",
														padding: "10px 12px",
														fontSize: 11,
														fontFamily: '"Poppins", sans-serif',
														color: "#444",
														boxShadow: "2px 2px 4px rgba(0,0,0,0.15)",
														maxWidth: 180,
														position: "absolute",
														top: 78,
														left: -4,
														transform: "translateY(-100%)",
													}}
												>
													{yellowImitaciones.includes("?") ? (
														<>
															<strong>¿Imitaciones?</strong>{" "}
															{yellowImitaciones
																.split("?")
																.slice(1)
																.join("?")
																.trim()}
														</>
													) : (
														yellowImitaciones
													)}
												</div>
											)}
										</div>
									)}
									{line.includes(":") ? (
										<>
											<strong>{line.split(":")[0]}:</strong>{" "}
											{line.split(":").slice(1).join(":").trim()}
										</>
									) : (
										line
									)}
								</li>
							))}
						</ul>
						{sabiasQueChinatown && (
							<div
								style={{
									position: "absolute",
									bottom: isSmallScreen ? 130 : 66,
									right: isSmallScreen ? "29%" : "33%",
								}}
							>
								<SabiasQueNY
									icono={sabiasQueChinatown.icono}
									texto={sabiasQueChinatown.texto}
								/>
							</div>
						)}
					</div>
				)}

				{(columbusSrc || columbusItems.length > 0) && (
					<div
						data-block-id="text-3"
						style={{
							display: "flex",
							alignItems: "flex-start",
							gap: 16,
							marginTop: isSmallScreen ? 0 : 12,
						}}
					>
						{columbusSrc && (
							<img
								src={columbusSrc}
								alt="Columbus Park"
								style={{
									width: "40%",
									height: 110,
									borderRadius: 12,
									objectFit: "cover",
								}}
							/>
						)}
						<div
							style={{
								width: "60%",
								fontSize: 13,
								fontFamily: '"Poppins", sans-serif',
								margin: 0,
								color: "#444",
							}}
						>
							<ul style={{ padding: 0, paddingLeft: 8 }}>
								{columbusItems.map((item, i) => (
									<li
										key={i}
										style={{
											marginBottom: isSmallScreen ? 8 : 0,
											marginTop: i === 0 ? -8 : 0,
										}}
									>
										{item.includes(":") ? (
											<>
												<strong>{item.split(":")[0]}:</strong>{" "}
												{item.split(":").slice(1).join(":").trim()}
											</>
										) : (
											item
										)}
									</li>
								))}
							</ul>
						</div>
					</div>
				)}

				{(comoLlegarTitle || comoLlegarItems.length > 0) && (
					<div
						data-block-id="text-4"
						style={{
							backgroundColor: "#e0f7fa",
							border: "3px solid #59c3d8",
							borderRadius: 12,
							padding: "16px 20px",
							fontSize: 12,
							fontFamily: '"Poppins", sans-serif',
							color: "#333",
							marginTop: isSmallScreen ? 90 : 2,
						}}
					>
						{comoLlegarTitle && (
							<h4
								style={{
									margin: 0,
									marginBottom: 8,
									fontSize: 13,
									fontWeight: 700,
									display: "flex",
									alignItems: "center",
									gap: 6,
									color: "#007a8d",
									textTransform: "uppercase",
								}}
							>
								{comoLlegarTitle}
							</h4>
						)}
						{comoLlegarItems.length > 0 && (
							<ul style={{ paddingLeft: 20, margin: 0, lineHeight: 1.5 }}>
								{comoLlegarItems.map((line, i) => (
									<li key={i}>
										{i === 1 && "También útil: "}
										{line.includes(" hasta ") ? (
											<>
												<strong>{line.split(" hasta ")[0]}</strong>
												{" hasta "}
												<em>
													{line.split(" hasta ").slice(1).join(" hasta ")}
												</em>
											</>
										) : (
											line
										)}
									</li>
								))}
							</ul>
						)}
					</div>
				)}

				{comidaSrc && (
					<img
						src={comidaSrc}
						alt="Food"
						style={{
							width: 80,
							position: "absolute",
							bottom: isSmallScreen ? 50 : 10,
							right: 0,
						}}
					/>
				)}
				{gastronomiaHtml && (
					<div
						style={{
							position: "absolute",
							bottom: isSmallScreen ? 110 : 30,
							right: 63,
							backgroundColor: "#fff8db",
							border: "2px solid #f5c400",
							borderRadius: "16px 16px 0px 16px",
							padding: "10px 12px",
							fontSize: 11,
							fontFamily: '"Poppins", sans-serif',
							color: "#444",
							boxShadow: "2px 2px 4px rgba(0,0,0,0.15)",
							maxWidth: 210,
						}}
					>
						<div
							style={{ fontFamily: '"Poppins", sans-serif', fontSize: 11 }}
							dangerouslySetInnerHTML={{ __html: gastronomiaHtml }}
						/>
					</div>
				)}
			</div>
		</Box>
	);
};

export default Template80;
